import axios from 'axios';

class AnswerRepository{

    constructor(token) {
        this.token = token;
    }

    async upload(answerId, file){
        
        const formData = new FormData();
        formData.append('document', file);
        
        const response = await axios.post(
            `${process.env.REACT_APP_API_HOST}answers/${answerId}/upload`, formData,
            {
                hearders: {
                Authorization: `Bearer ${this.token}`,
                'Content-Type': 'multipart/form-data'
                }
            }
        );

        return response; 

    }

    async answer(answerId, data = []){
        const response = await axios.put(
            `${process.env.REACT_APP_API_HOST}answers/${answerId}`, data,
            { headers: {
                Authorization: `Bearer ${this.token}`,
              },
            }
        );

        return response;
    }

    async deleteAttachment(attachmentId, token){
        const response = await axios.delete(
            `${process.env.REACT_APP_API_HOST}answer-attachments/${attachmentId}`,
            { headers: {
                Authorization: `Bearer ${token}`,
              },
            }
        );

        return response;
    }

}

export default AnswerRepository;